import * as mutationTypes from './mutation-types'
import api from '@/store/api/bundle/metric'

const initialState = () => ({
    charts: [],
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        charts: state => state.charts
    },
    actions: {
        /**
         * @param {ChartQuery} data
         * @returns {Promise<*>}
         */
        listCharts: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listCharts(data)
                commit(mutationTypes.SET_CHARTS, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetCharts: ({commit}) => commit(mutationTypes.RESET_CHARTS),
    },
    mutations: {
        [mutationTypes.SET_CHARTS]: (state, data) => state.charts = data,
        [mutationTypes.RESET_CHARTS]: (state) => state.charts = initialState().charts,
    }
}
